import React from "react"
export function Print(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M8 1.75a.75.75 0 01.743.648l.013.23a1.25 1.25 0 002.488 0l.013-.23a.75.75 0 01.641-.641L12 1.75h4.497a.75.75 0 01.743.648l.007.102v15a.75.75 0 01-.648.743l-.102.007H12a.75.75 0 01-.74-.623l-.01-.099-.003-.118a1.25 1.25 0 00-2.49-.036l-.014.23a.75.75 0 01-.641.64L8 18.251l-4.503-.001a.75.75 0 01-.743-.648l-.007-.102v-15a.75.75 0 01.648-.743l.102-.007H8zm-.646 1.5H4.247V8H7v1.5H4.246l.001 7.25h3.108l.017-.057a2.753 2.753 0 012.269-1.916l.192-.018.167-.005c1.148 0 2.139.705 2.55 1.729l.063.173.027.094h3.107V9.5H13V8h2.746l.001-4.75h-3.102l-.016.058a2.753 2.753 0 01-2.27 1.919l-.191.018L10 5.25a2.751 2.751 0 01-2.572-1.776l-.057-.166-.017-.058zM11.5 8v1.5h-3V8h3z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__print"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
